import React from "react";
import CSVIcon from "../../../assets/icons/CSVicon.svg";
import PDFIcon from "../../../assets/icons/PDFicon.svg";
import CloseIcon from "@mui/icons-material/Close";
import {
  convertToCSV,
  exportLogsToPDF,
  downloadFile,
} from "../utils/exportUtils";
import {
  convertTableSnapshotToCSV,
  exportTableSnapshotToPDF,
  getRenderedTableSnapshot,
} from "../../../shared/utils/converter";

const ExportModal = ({
  isOpen,
  onClose,
  exportType,
  setExportType,
  displayLogs,
  columns,
  getTableElement,
}) => {
  if (!isOpen) return null;

  const handleCSVExport = () => {
    setExportType("csv");

    const table = typeof getTableElement === "function" ? getTableElement() : null;
    const snapshot = getRenderedTableSnapshot(table);

    if (snapshot?.headers?.length) {
      const csv = convertTableSnapshotToCSV(snapshot);
      if (csv) {
        downloadFile("logs.csv", csv, "text/csv");
      }
    } else {
      const csv = convertToCSV(displayLogs, columns);
      downloadFile("logs.csv", csv, "text/csv");
    }

    onClose();
  };

  const handlePDFExport = () => {
    setExportType("pdf");

    const table = typeof getTableElement === "function" ? getTableElement() : null;
    const snapshot = getRenderedTableSnapshot(table);

    if (snapshot?.headers?.length) {
      exportTableSnapshotToPDF(snapshot, "logs", "PBXScribe Transcription Logs");
    } else {
      exportLogsToPDF(displayLogs, columns);
    }

    onClose();
  };

  return (
    <div className="absolute max-sm:left-1/2 max-sm:transform max-sm:-translate-x-1/2 sm:right-0 mt-2 z-50 bg-white rounded-xl shadow-lg border border-line min-w-[240px] p-4">
      <div className="flex items-center justify-between mb-3">
        <span className="text-base font-bold text-primary">Select Export</span>
        <button
          className="text-primary hover:text-gray-700 leading-tight border border-primary rounded-full !w-5 !h-5 flex items-center justify-center"
          onClick={onClose}
          aria-label="Close"
        >
          <CloseIcon fontSize="small" className="!w-4"/>
        </button>
      </div>
      <div className="flex gap-3">
        <button
          className={`flex items-center gap-2 px-3 pr-6 py-2 rounded-lg border border-dashed text-sm font-bold ${
            exportType === "csv"
              ? "bg-content/20 border-content text-primary"
              : "bg-white border-content text-primary hover:bg-slate-200"
          }`}
          onClick={handleCSVExport}
        >
          <img className="w-fit h-fit" src={CSVIcon} alt="CSV Icon" />
          CSV
        </button>
        <button
          className={`flex items-center gap-2 px-3 py-2 pr-6 rounded-lg border border-dashed text-sm font-bold ${
            exportType === "pdf"
              ? "bg-content/20 border-content text-primary"
              : "bg-white border-content text-primary hover:bg-slate-200"
          }`}
          onClick={handlePDFExport}
        >
          <img className="w-fit h-fit" src={PDFIcon} alt="PDF Icon" />
          PDF
        </button>
      </div>
    </div>
  );
};

export default ExportModal;
